import type { RouteAccess } from '@/config/routeManifest';

export type RouteAccessDecision = 'allow' | 'loading' | 'sign-in' | 'forbidden';

interface RouteAccessContext {
  access: RouteAccess;
  authLoading: boolean;
  authenticated: boolean;
  admin: boolean;
  client: boolean;
  staff: boolean;
}

export const resolveRouteAccess = ({
  access,
  authLoading,
  authenticated,
  admin,
  client,
  staff,
}: RouteAccessContext): RouteAccessDecision => {
  if (access === 'public' || access === 'development' || access === 'system') {
    return 'allow';
  }

  if (authLoading) return 'loading';
  if (!authenticated) return 'sign-in';
  if (access === 'admin' && !admin) return 'forbidden';
  // Admins oversee every workspace, so they are never locked out of
  // client or staff areas.
  if (access === 'client' && !client && !admin) return 'forbidden';
  if (access === 'staff' && !staff && !admin) return 'forbidden';

  return 'allow';
};
